import { render, staticRenderFns } from "./PhotoGallerySection.vue?vue&type=template&id=492a5801&scoped=true"
import script from "./PhotoGallerySection.vue?vue&type=script&lang=js"
export * from "./PhotoGallerySection.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallerySection.vue?vue&type=style&index=0&id=492a5801&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a5801",
  null
  
)

export default component.exports